import { format, isToday, isTomorrow, isYesterday } from 'date-fns';

export function getFlightDayAndDate(timezoneDate: Date) {
	const dateFormatString = 'MM/dd/yyyy';

	if (isYesterday(timezoneDate)) {
		return `Yesterday, ${format(timezoneDate, dateFormatString)}`;
	}

	if (isToday(timezoneDate)) {
		return `Today, ${format(timezoneDate, dateFormatString)}`;
	}

	if (isTomorrow(timezoneDate)) {
		return `Tomorrow, ${format(timezoneDate, dateFormatString)}`;
	}

	return `${format(timezoneDate, `${`EEEE`}, ${dateFormatString}`)}`;
}
